<div *ngIf="encryptStno == ''" style="margin: auto;max-width: 200px;margin-top: 10vw;">
  學號：<input type="text" #test>
  <!-- 密碼：<input type="password" #pwd> -->
  <br><br>
  <button type="button" (click)="testLogin(test.value, true)">測試登入</button>
</div>
<div *ngIf="encryptStno != ''">
  登入中, 請稍候
</div>
